import { DARK_MODE, GRAY_SCALE } from 'constants/ThemeConstant';
import { createTheme } from './createTheme';
import { baseTheme } from './baseTheme';
import { rgba, mixOnBackground, buildThemeCheckboxScopedStyles, buildThemeGroupRowCssVariables } from './utils';
const DARK_LAYOUT_BG = '#1b2531';
const DARK_PRIMARY = '#0052AD';
/** Submenu (custom-menu) — nền sidebar dark */
const DARK_CUSTOM_MENU_BG = DARK_MODE.BG_COLOR;
/** Cột module — cùng tông custom menu, sáng nhẹ (~10% white) */
const DARK_MODULE_MENU_BG = mixOnBackground(DARK_CUSTOM_MENU_BG, 1.09, GRAY_SCALE.WHITE);
/** Modal / Drawer / Popover — nền elevated dark */
const DARK_ELEVATED_SURFACE = DARK_MODE.BG_COLOR;

export const darkScopedStyles = `${buildThemeCheckboxScopedStyles('dark')}
${buildThemeGroupRowCssVariables(DARK_PRIMARY, '#FFD700', 'dark', DARK_LAYOUT_BG)}
body[data-theme='dark'] .so-navigate-process-steps.ant-steps-vertical .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon {
    color: ${GRAY_SCALE.WHITE} !important;
}
body[data-theme='dark'] .bom-navigate-process-menu.ant-menu .ant-menu-item-selected,
body[data-theme='dark'] .bom-navigate-process-menu.ant-menu .ant-menu-item-selected .anticon,
body[data-theme='dark'] .bom-navigate-process-menu.ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title,
body[data-theme='dark'] .bom-navigate-process-menu.ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title .anticon,
body[data-theme='dark'] .asm-asset-detail-step-menu.ant-menu .ant-menu-item-selected,
body[data-theme='dark'] .asm-asset-detail-step-menu.ant-menu .ant-menu-item-selected .anticon,
body[data-theme='dark'] .asm-asset-detail-step-menu.ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title,
body[data-theme='dark'] .asm-asset-detail-step-menu.ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title .anticon,
body[data-theme='dark'] .asm-asset-audit-request-form-step-menu.ant-menu .ant-menu-item-selected,
body[data-theme='dark'] .asm-asset-audit-request-form-step-menu.ant-menu .ant-menu-item-selected .anticon,
body[data-theme='dark'] .asm-asset-audit-request-form-step-menu.ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title,
body[data-theme='dark'] .asm-asset-audit-request-form-step-menu.ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title .anticon {
    color: ${GRAY_SCALE.WHITE} !important;
}
body[data-theme='dark'] .nagaco-folder-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active .ant-tabs-tab-btn,
body[data-theme='dark'] .nagaco-folder-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active .nagaco-folder-tab-label,
body[data-theme='dark'] .nagaco-folder-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active .nagaco-folder-tab-label .anticon {
    color: ${GRAY_SCALE.WHITE} !important;
}`;

export const darkTheme = createTheme({
    primaryColor: '#1b2531',
    successColor: '#52c41a',
    warningColor: '#faad14',
    errorColor: '#ff4d4f',

    bgColor: DARK_MODE.BG_COLOR,
    textColor: DARK_MODE.TEXT_COLOR,
    borderColor: DARK_MODE.BORDER_BASE_COLOR,
    bodyBg: DARK_LAYOUT_BG,
    colorBgLayout: DARK_LAYOUT_BG,
    colorBgElevated: DARK_ELEVATED_SURFACE,

    moduleMenuBg: DARK_MODULE_MENU_BG,
    siderBg: DARK_CUSTOM_MENU_BG,
    customMenuBg: DARK_CUSTOM_MENU_BG,
    moduleMenuIconColor: GRAY_SCALE.WHITE,
    moduleMenuItemColor: DARK_MODE.WHITE,
    moduleMenuItemSelectedBg: DARK_MODE.WHITE,
    moduleMenuItemSelectedColor: '#1b2531',
    menuGroupTitleColor: DARK_MODE.WHITE,
    headerNavBorderColor: '#1b2531', 

    customMenuItemSelectedColor: GRAY_SCALE.WHITE,
    customMenuItemSelectedBg: DARK_MODE.ACTIVE_BG_COLOR,
    customMenuItemSelectedIconColor: GRAY_SCALE.WHITE,
    customMenuItemSelectedBorderColor: GRAY_SCALE.WHITE,

    footerBg: DARK_MODE.BG_COLOR,
    footerTextColor: DARK_MODE.TEXT_COLOR,
    footerBorderColor: DARK_MODE.BORDER_BASE_COLOR,
    colorTextDescription: GRAY_SCALE.WHITE,
    componentOverrides: {
        Button: {
            defaultBorderColor: 'rgba(255,255,255,.15)',
            defaultShadow: 'none',
            controlOutline: 'transparent',
            colorBorder: DARK_MODE.BORDER_BASE_COLOR,
            colorText: DARK_MODE.TEXT_COLOR,
            backgroundColor: DARK_MODE.BG_COLOR,
        },
        Card: {
            colorTextHeading: DARK_MODE.TEXT_COLOR,
            colorBgContainer: DARK_MODE.BG_COLOR,
            colorBorderSecondary: DARK_MODE.BG_COLOR,
        },
        Tabs: {
            colorText: DARK_MODE.TEXT_COLOR,
            itemColor: DARK_MODE.TEXT_COLOR,
            itemSelectedColor: GRAY_SCALE.WHITE,
            itemHoverColor: DARK_PRIMARY,
            cardBg: DARK_MODE.BG_COLOR,
            inkBarColor: DARK_PRIMARY,
        },
        Layout: {
            bodyBg: DARK_LAYOUT_BG,
            headerBg: DARK_MODE.BG_COLOR,
            siderBg: DARK_CUSTOM_MENU_BG,
        },
        Menu: {
            darkItemBg: 'transparent',
            darkItemColor: GRAY_SCALE.GRAY_DARK,
            darkItemSelectedBg: DARK_MODE.ACTIVE_BG_COLOR,
            darkItemSelectedColor: GRAY_SCALE.WHITE,
            itemSelectedBg: DARK_MODE.ACTIVE_BG_COLOR,
            itemSelectedColor: GRAY_SCALE.WHITE,
            darkItemHoverBg: DARK_MODE.HOVER_BG_COLOR,
            darkItemHoverColor: GRAY_SCALE.GRAY_DARK,
            darkSubMenuItemBg: DARK_MODE.BG_COLOR,
            popupBg: DARK_MODE.BG_COLOR,
            activeBarWidth: 0,
            boxShadowSecondary: DARK_MODE.DROP_DOWN_SHADOW,
        },
        Dropdown: {
            boxShadowSecondary: DARK_MODE.DROP_DOWN_SHADOW,
        },
        Calendar: {
            controlItemBgActive: '#303a4e',
        },
        Select: {
            controlOutline: 'transparent',
            controlItemBgActive: DARK_MODE.ACTIVE_BG_COLOR,
            controlItemBgHover: DARK_MODE.HOVER_BG_COLOR,
            boxShadowSecondary: DARK_MODE.DROP_DOWN_SHADOW,
            colorBorderSecondary: DARK_MODE.BG_COLOR,
        },
        Input: {
            controlOutline: 'transparent',
        },
        DatePicker: {
            controlOutline: 'transparent',
            boxShadowSecondary: DARK_MODE.DROP_DOWN_SHADOW,
            controlItemBgActive: DARK_MODE.ACTIVE_BG_COLOR,
            controlItemBgHover: DARK_MODE.HOVER_BG_COLOR,
        },
        Breadcrumb: {
            itemColor: DARK_MODE.TEXT_COLOR,
            lastItemColor: DARK_MODE.HEADING_COLOR,
            linkColor: DARK_MODE.TEXT_COLOR,
            linkHoverColor: DARK_PRIMARY,
            separatorColor: DARK_MODE.TEXT_COLOR,
        },
        Modal: {
            contentBg: DARK_ELEVATED_SURFACE,
            headerBg: DARK_ELEVATED_SURFACE,
            footerBg: DARK_ELEVATED_SURFACE,
            titleColor: DARK_MODE.HEADING_COLOR,
            colorText: DARK_MODE.TEXT_COLOR,
        },
        Drawer: {
            colorBgElevated: DARK_ELEVATED_SURFACE,
            colorText: DARK_MODE.TEXT_COLOR,
            colorTextHeading: DARK_MODE.HEADING_COLOR,
        },
        Popover: {
            colorBgElevated: DARK_ELEVATED_SURFACE,
            colorText: DARK_MODE.WHITE,
        },
        Table: {
            colorText: DARK_MODE.TEXT_COLOR,
            // colorTextHeading: DARK_MODE.HEADING_COLOR,
            // headerBg:  baseTheme.colorPrimary,
        },
        Steps: {
            colorText: DARK_MODE.TEXT_COLOR,
            colorTextDescription: DARK_MODE.TEXT_COLOR,
            colorPrimary: DARK_PRIMARY,
            colorSplit: DARK_MODE.BORDER_BASE_COLOR,
        },
        
    },
});
